import {OrderItem} from './order-item';

export class OrderItemSummary {
    key: string;
    items: OrderItem[] = [];
    total: number;
}
